import Vue from 'vue'
import * as types from '@/store/mutation-types'

export default {
    [types.SET_APP_CONFIG]: (state, appConfig) => {
        Vue.set(state, 'appConfig', appConfig);
    },
    [types.SET_CURRENT_BACKGROUND]: (state, currentBackground) => {
        Vue.set(state, 'currentBackground', currentBackground);
    },
    [types.SET_CURRENT_APP_SEGMENT]: (state, appSegment) => {
        Vue.set(state, 'appSegment', appSegment);
    }
}
